import { FileText } from "lucide-react";
import { ReactNode } from "react";

interface EmptyStateProps {
  message?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ 
  message = "No items found",
  icon = <FileText className="h-8 w-8 text-muted-foreground" />,
  action 
}: EmptyStateProps) {
  return (
    <div className="text-center py-8">
      <div className="flex flex-col items-center gap-2">
        {icon}
        <p className="text-muted-foreground">{message}</p>
        {action}
      </div>
    </div>
  );
}

